import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import { button } from '@sparta.global.helpers/button-helper/dist/es6.js';
import { select } from '@sparta.global.helpers/select-helper/dist/es6.js';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<form novalidate>\n  <div class=\"row\">\n    <div id=\"faq-selector\">\n      <div class=\"medium-12 column medium-centered horiz-center-align\">\n        <div class=\"faq-selector-container\">\n          <h2 class=\"input-caption\">\n            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"inputCaption") : stack1), depth0)) != null ? stack1 : "")
    + "\n          </h2>\n          <div class=\"input-box\">\n            "
    + container.escapeExpression((lookupProperty(helpers,"select")||(depth0 && lookupProperty(depth0,"select"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"faqPageSelector") : stack1),{"name":"select","hash":{},"data":data,"loc":{"start":{"line":11,"column":12},"end":{"line":11,"column":46}}}))
    + "\n            "
    + ((stack1 = (lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"faqButtonNonLink") : stack1),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":12,"column":12},"end":{"line":12,"column":47}}})) != null ? stack1 : "")
    + "\n          </div>\n        </div>\n      </div>\n    </div>\n    <div id=\"returnToMenu\">\n       "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"returnToMenu") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":18,"column":7},"end":{"line":18,"column":36}}})) != null ? stack1 : "")
    + "\n    </div>\n  </div>\n</form>\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/faq-selector-cc-module",
  "version": "2.0.0",
  "id": "faqSelectorCcModule",
  "containerID": "creditCardsFaqSelectorCcModule",
  "moduleName": "credit-cards-faq-selector-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "faq-selector-cc-module",
  "data": {
    "init": "faqSelectorCcModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        button,
        select,
        link
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    button,
    select,
    link
  },
  "dependencies": {
    "@sparta.global.helpers/button-helper": "^1.0.0",
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/**
 * faq-selector-cc-module
 * module_js_id: faqSelectorCcModuleJS
 */

/**
 * Creates a faqSelectorCcModuleJS class.
 * @returns {Object} faqSelectorCcModuleJS class.
 */
class faqSelectorCcModuleJS extends Module {
  /**
   * @param {object} options - options object
   * @param {object} context - context object
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Sets intial displayed values.
   * @return {Void} undefined
   */
  init() {
    this.setSelectedFAQ();
    document.getElementById('change-faq-button').onclick = () => this.changeFAQClickHandler();
    this.settings.$target.spartaInputs();
  }

  /**
   * Updates the faq selector to the correct page.
   * @return {Void} undefined
   */
  setSelectedFAQ() {
    const faqSelector = document.getElementById('faqSelector');
    const {
      options
    } = faqSelector;
    const currentFAQ = window.location.pathname;
    if (currentFAQ) {
      for (let i = 0; i < options.length; i += 1) {
        if (options[i].value === currentFAQ) {
          faqSelector.selectedIndex = i;
          break;
        }
      }
    }
  }

  /**
   * Directs browser to a new FAQ page.
   * @param  {Event} event Event object
   * @return {Void} undefined
   */
  changeFAQClickHandler() {
    const selectedFAQ = document.getElementById('faqSelector').dataset.val;
    window.location.href = selectedFAQ;
  }
}
registerModuleClass({
  moduleClass: faqSelectorCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { faqSelectorCcModuleJS as default, moduleConfig };
